import React from 'react'
import { getValidUrl } from '../../../utils';

const ReviewJobs = ({ jobList }: any) => {

    if (jobList?.length <= 0) return null;

    return (
        <div className="review-jobs__table">
            {/* Table header */}
            <div className="review-jobs__table-header">
                <span>Production</span>
                <span>Department</span>
                <span>Positions</span>
                <span>Link</span>
            </div>

            <hr className="review-jobs__divider" />

            {/* Table rows */}
            {jobList?.map((job: any) => (
                <div key={job.id} className="review-jobs__row">
                    <span className="review-jobs__cell">{job?.production}</span>
                    <span className="review-jobs__cell">{job?.department}</span>
                    <span className="review-jobs__cell">{job?.position}</span>
                    <a
                        href={getValidUrl(job?.imdb_link)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="review-jobs__imdb-badge"
                    >
                        IMDb
                    </a>
                </div>
            ))}

            <hr className="review-jobs__divider" />
        </div>
    )
}

export default ReviewJobs